import { Vehicle } from "@commons/models/domain/Vehicle";
import { VehicleControlIndicator } from "@commons/models/domain/VehicleControlIndicator";

export function filterBinaryParams(param: VehicleControlIndicator): boolean {
    const hiddenParamsByName = ['BZ - brak zasilania'];
    const ifHiddenParamByName = hiddenParamsByName.includes(param.Nm);
    if (ifHiddenParamByName) {
        return false;
    }
    const ifValueNull = param.LV === null;
    if (ifValueNull) {
        return false;
    }
    const ifServiceParam = param.Nm.slice(0, 1) === '#';
    if (ifServiceParam) {
        return false;
    }
   return !param.Nm.includes('OUT');
}

export function findVehicleSpeedParamValue(data: Vehicle): number {
    const controls = data.ControlIndicators;
    let value = (controls || []).filter(o => o && o.Group === 12);
    let cValue = (value && value.length > 0 && value[0].LV) ? value[0].LV : null;
    return cValue?.V;
};

export function isVehicleBlocked(data: Vehicle): boolean {
    const control = data.blockerParametrId ? data.ControlIndicators?.find(item => item.Id === data?.blockerParametrId) : null;
    const controlOut2 = data.blockerParametrIdOut2 ? data.ControlIndicators?.find(item => item.Id === data?.blockerParametrIdOut2) : null;
    return control?.LV?.V || controlOut2?.LV?.V;
};